import { render, staticRenderFns } from "./IngredientRecipes.vue?vue&type=template&id=42950f28&"
import script from "./IngredientRecipes.vue?vue&type=script&lang=ts&"
export * from "./IngredientRecipes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports